import { useEffect, useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Modal } from "@mui/material";
import { LuX } from "react-icons/lu";
import { appConstants } from "utils/appConstants";

export default function InvoiceAttachmentPreview({ attachment, onClose, quotationStyle = false }) {
  const [fileURL, setFileURL] = useState("");

  useEffect(() => {
    if (!attachment) {
      setFileURL("");
      return;
    }
    const url = attachment.file
      ? URL.createObjectURL(attachment.file)
      : `${appConstants.baseURL}quotation/viewUploadedQuotationDocument?fileName=${encodeURIComponent(
          "/" + attachment.documentFileName
        )}`;
    setFileURL(url);
    return () => {
      if (attachment.file) URL.revokeObjectURL(url);
    };
  }, [attachment]);

  if (!attachment) return null;

  const name = attachment.documentName || attachment.documentFileName || "Attachment";
  const type = String(attachment.file?.type || attachment.fileType || "").toLowerCase();
  const filename = attachment.file?.name || attachment.documentFileName || "";
  const isImage = /^(image|png|jpe?g|gif|webp|bmp|svg)/.test(type);
  const isPdf = type.includes("pdf") || /\.pdf$/i.test(filename);

  if (quotationStyle) {
    return (
      <Modal
        open
        onClose={onClose}
        hideBackdrop
        className="quotation-dialog-scrim document-preview-overlay"
        onClick={onClose}
        sx={{ zIndex: 10001 }}
      >
        <div
          className="quotation-document-preview"
          role="dialog"
          aria-modal="true"
          aria-label={name}
          tabIndex={-1}
          onClick={(event) => event.stopPropagation()}
        >
          <button type="button" className="quotation-document-preview-close" onClick={onClose} aria-label="Close document preview">
            <LuX aria-hidden="true" />
          </button>
            {fileURL && (isImage ? (
              <img src={fileURL} alt={name} />
            ) : (
              <iframe
                title={name}
                className={isPdf ? "quotation-document-preview-pdf" : undefined}
                src={isPdf ? `${fileURL}#toolbar=0&navpanes=0&view=FitH` : fileURL}
              />
            ))}
        </div>
      </Modal>
    );
  }

  return (
    <Dialog
      open
      className="document-preview-overlay"
      onClose={onClose}
      fullWidth
      maxWidth="md"
      aria-labelledby="invoice-attachment-preview-title"
      sx={{ zIndex: 10001 }}
      PaperProps={{
        sx: {
          background: "var(--surface-primary, #fff)",
          color: "var(--text-primary, #142624)",
        },
      }}
    >
      <DialogTitle id="invoice-attachment-preview-title">{name}</DialogTitle>
      <DialogContent>
        {fileURL && (isImage ? (
          <img src={fileURL} alt={name} style={{ width: "100%", maxHeight: "65vh", objectFit: "contain" }} />
        ) : isPdf ? (
          <iframe title={name} src={fileURL} style={{ width: "100%", height: "65vh", border: 0 }} />
        ) : (
          <p>Download this attachment to view it.</p>
        ))}
      </DialogContent>
      <DialogActions>
        <Button component="a" href={fileURL} download={attachment.file?.name || name} disabled={!fileURL}>
          Download
        </Button>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
